module.exports = __webpack_public_path__ + "static/media/1_007.9feed64d.jpeg";